import React from "react";

const ErrorCustom = ({errors,name}) => {
  if(name.includes('.')){
    const tag = getDescendantProp(errors, name);
    if(tag) return <div className="errorCustom">{tag.message}</div>
    return null
  } else
  if (errors[name]) {
    return <div className="errorCustom">{errors[name].message}</div>
  } else { 
    return null; 
  }
}

function getDescendantProp(obj, desc) {
  var arr = desc.split(".");
  while(arr.length && (obj = obj[arr.shift()]));
  return obj;
}

export default ErrorCustom;